module.exports = __webpack_public_path__ + "img/default-avatar.4cf4d53.png";